import React from 'react';

const CLUB_EMAIL = 'tgt@tennis-thedinghausen.de';

function DrinkPaidPanel({ total, onClose, onPaid }) {
    const copy = (text) => {
        navigator.clipboard.writeText(text).catch(() => {});
    };

    return (
        <div className="drink-paid-overlay">
            <div className="drink-paid-panel">
                <h3>Danke!</h3>
                <p>Bitte bezahle <strong>{total} €</strong> bar oder überweise via PayPal an:</p>
                <div className="drink-paid-row">
                    <code className="drink-paid-value">{CLUB_EMAIL}</code>
                    <button className="drink-copy-btn" onClick={() => copy(CLUB_EMAIL)}>Kopieren</button>
                </div>
                <div className="drink-paid-row">
                    <span className="drink-paid-value">{total} €</span>
                    <button className="drink-copy-btn" onClick={() => copy(total)}>Kopieren</button>
                </div>
                <a
                    href="https://www.paypal.com"
                    target="_blank"
                    rel="noreferrer"
                    className="drink-paypal-btn"
                >
                    PayPal öffnen
                </a>
                <button className="drink-pay-btn drink-paid-confirm" onClick={onPaid}>Ich habe bezahlt</button>
                <button className="drink-paid-close" onClick={onClose}>Abbrechen</button>
            </div>
        </div>
    );
}

export default DrinkPaidPanel;
